import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import exitClearenceService from "../../services/exitClearenceService";
import {AUTH_TOKEN} from "../../constants/AuthConstant";
import Cookies from "js-cookie";

export const initialState = {
    loading: false,
    data: [],
    jml_data: 0,
}

export const getDataExitClearence = createAsyncThunk('exitClearence/data', async (data, { rejectWithValue }) => {
    try {
        const response = await exitClearenceService.data(Cookies.get(AUTH_TOKEN), data)
        return response
    } catch (err) {
        return rejectWithValue(err.response?.data || 'Error')
    }
})

export const updateExitClearence = createAsyncThunk('exitClearence/update', async (data, { rejectWithValue }) => {
    try {
        const response = await exitClearenceService.update(data)
        return response
    } catch (err) {
        return rejectWithValue(err.response?.data || 'Error')
    }
})

export const cetakPaklaring = createAsyncThunk('exitClearence/cetakPaklaring', async (data, { rejectWithValue }) => {
    try {
        const response = await exitClearenceService.cetakPaklaring(data)
        return response
    } catch (err) {
        return rejectWithValue(err.response?.data || 'Error')
    }
})

export const exitClearenceSlice = createSlice({
    name: 'exitClearence',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getDataExitClearence.pending, (state) => {
                state.loading = true
            })
            .addCase(getDataExitClearence.fulfilled, (state, action) => {
                state.loading = false
                state.data = action.payload?.data ?? []
                state.jml_data = action.payload?.jml_data ?? 0
            })
            .addCase(getDataExitClearence.rejected, (state) => {
                state.loading = false
            })
    },
})

export default exitClearenceSlice.reducer
